export function Button({
  type,
  variant = 'primary',
  onClick,
  disabled = false,
  customClasses,
  children,
}) {
  const variantClass = variant === 'disabled' ? 'disabled-btn' : 'btn-primary';
  const classes = `btn ${variantClass}${customClasses ? ` ${customClasses}` : ''}`;
  return (
    <button type={type} onClick={onClick} disabled={disabled} className={classes}>
      {children}
    </button>
  );
}
